import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3f3fca19"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed top-20 right-0 left-0 md:left-[unset] md:right-6 lg:right-8 md:rounded-lg border border-gray-300 px-6 py-4 text-sm max-w-xs bg-white text-gray-800 shadow-lg transform transition-transform duration-200 ease-in-out",
  style: {"z-index":"1000"}
}
const _hoisted_2 = { class: "flex items-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-light-green",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8-3a1 1 0 00-1 1v2a1 1 0 002 0V8a1 1 0 00-1-1zm0 8a1 1 0 100-2 1 1 0 000 2z",
      "clip-rule": "evenodd"
    })
  ])
], -1))
const _hoisted_4 = { class: "ml-3 flex-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 8.586L4.707 3.293a1 1 0 00-1.414 1.414L8.586 10l-5.293 5.293a1 1 0 001.414 1.414L10 11.414l5.293 5.293a1 1 0 001.414-1.414L11.414 10l5.293-5.293a1 1 0 00-1.414-1.414L10 8.586z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

import { ref, onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'alert',
  setup(__props) {

const showInfo = ref(false);

onMounted(() => {
  setTimeout(() => {
    showInfo.value = true;
  }, 100);
  setTimeout(() => {
    showInfo.value = false;
  }, 3000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      (showInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _createElementVNode("div", {
                class: "ml-4 flex-shrink-0 flex cursor-pointer hover:scale-110 transition-all",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showInfo.value = false))
              }, _hoisted_6)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})